import { ColDef, ICellRendererParams } from "ag-grid-community";
import { Attachment } from "@/services/cloudchipr.api";
import { AttachmentCell } from "@/components/common/attachment-cell/AttachmentCell";

export const attachmentsColumnDefs: ColDef = {
  minWidth: 210,
  sortable: false,
  field: "resource.attachments",
  headerName: "Attachments",
  valueGetter: ({ data }) =>
    data?.resource?.attachments
      ?.map((attachment: Attachment) => attachment.id)
      ?.join(", "),
  cellRenderer: ({ data }: ICellRendererParams) => {
    return <AttachmentCell resource={data?.resource} />;
  },
};
